module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-boost-64.499ae8e3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-boost-64.png
// module id = 3191
// module chunks = 11